import { faUserTie } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import H4 from '@/components/H4'

const IconWrapper = styled.span`
  margin-right: 10px;
`

const Title = () => (
  <H4>
    <IconWrapper>
      <FontAwesomeIcon size="1x" icon={faUserTie} />
    </IconWrapper>{' '}
    Employer Reference
  </H4>
)

export default Title
